import { env } from '@/main/config'
import { SupabaseEdgeHttpClient } from '@/shared/infra/http'
import { EdgeConfirmCheckoutRepository } from '@/modules/auth/infra/repositories'
import type { ConfirmCheckout } from '@/modules/auth/use-cases'

export function makeConfirmCheckout(): ConfirmCheckout {
  return new EdgeConfirmCheckoutRepository(
    (accessToken) => new SupabaseEdgeHttpClient(env.edgeFunctionsBaseUrl, async () => accessToken),
  ).execute
}
